import { useState } from "react";
import { v4 as uuid } from "uuid";

export const useUuid = () => {
  const [id] = useState<string>(uuid());
  return id;
};
